import * as React from 'react';
import { withRouter, Route } from 'react-router-dom';
import { observer } from 'mobx-react';
import { KassesPage } from './KassesPage';
import { KassaDetailsPage } from './KassaDetailsPage';
import KassesLayout from './KassesLayout';

@observer
class KassesRouterComponent extends React.Component<any, any> {
    render() {
        return (
            <KassesLayout>
                <Route path='/kassesmanagement/kasses' component={KassesPage} />
                <Route path='/kassesmanagement/kassa/:deviceId?' component={KassaDetailsPage} />
            </KassesLayout>
        );
    }
}

const KassesRouter = withRouter(KassesRouterComponent)
export default KassesRouter;